module.exports = __webpack_public_path__ + "img/C07TechSkirmisherChampion_ua.d2c7aab3.webp";